export const StepsActionCreators = {
  setLastStep: (lastStep) => ({
    type: "SET_LAST_STEP",
    payload: lastStep,
  }),
};
